module.exports = __webpack_public_path__ + "static/media/ecosentino.fe46b6cc.svg";